(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["oravella-illustrative-reviews"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    if (root.dataset.reviewsReady) return;
    root.dataset.reviewsReady = 'true';
    const track = root.querySelector('.oravella-reviews__track');
    const pause = root.querySelector('[data-review-pause]');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    let stopped = reduced.matches;
    let hovering = false;
    let timer;
    function label() {
      pause.textContent = stopped ? pause.dataset.play : pause.dataset.pause;
      pause.setAttribute('aria-pressed', String(stopped));
    }
    function move(direction) {
      const card = track.querySelector('article');
      if (!card) return;
      const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap);
      const end = track.scrollWidth - track.clientWidth;
      const next = direction > 0 && track.scrollLeft >= end - 3 ? 0 : track.scrollLeft + direction * step;
      track.scrollTo({left: next, behavior: reduced.matches ? 'instant' : 'smooth'});
    }
    root.querySelector('[data-review-prev]').addEventListener('click', () => {stopped = true; label(); move(-1);});
    root.querySelector('[data-review-next]').addEventListener('click', () => {stopped = true; label(); move(1);});
    pause.addEventListener('click', () => {stopped = !stopped; label();});
    root.addEventListener('mouseenter', () => hovering = true);
    root.addEventListener('mouseleave', () => hovering = false);
    track.addEventListener('pointerdown', () => {stopped = true; label();});
    track.addEventListener('keydown', event => {
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault(); stopped = true; label(); move(event.key === 'ArrowRight' ? 1 : -1);
      }
    });
    reduced.addEventListener('change', () => {if (reduced.matches) {stopped = true; label();}});
    const observer = new IntersectionObserver(entries => {
      clearInterval(timer);
      if (entries[0].isIntersecting) timer = setInterval(() => {
        if (!stopped && !hovering && !document.hidden && !root.contains(document.activeElement)) move(1);
      }, 6500);
    });
    observer.observe(root);
    document.addEventListener('shopify:section:unload', event => {
      if (event.target.contains(root)) {clearInterval(timer); observer.disconnect();}
    }, {once:true});
    label();
  }
  document.querySelectorAll('.oravella-reviews').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.oravella-reviews').forEach(init));
})();

  } catch(e) { console.error(e); }
})();
})();
